<template>
  <validation-observer ref="FaultSupportResult" class="form">
    <form ref="form" class="form">
      <validation-provider
        name="Sonuç"
        :rules="{ required: true }"
        v-slot="validationContext"
      >
        <b-row>
          <b-col sm="4"> <label for="name"> Sonuç </label> </b-col>
          <b-col sm="8">
            <b-form-input
              id="name"
              v-model="name"
              :state="getValidationState(validationContext)"
              aria-describedby="live-feedback"
            />
            <b-form-invalid-feedback id="live-feedback" class="text-left">{{
              validationContext.errors[0]
            }}</b-form-invalid-feedback>
          </b-col>
        </b-row>
      </validation-provider>
    </form>
  </validation-observer>
</template>

<script>
export default {
  data() {
    return {
      name: null,
    };
  },
  props: {
    data: Object,
    changeData: Function,
    save: Boolean,
    saveState: Function,
    modalName: String,
    modalEvent: Function,
  },
  watch: {
    save: async function (data) {
      if(!data) return
      this.$refs.FaultSupportResult.validate().then(async success => {
        if (!success) return this.saveState(false)
        const data = { name: this.name }

        if (this.modalName == 'add') {
          await this.$store.dispatch('addFaultSupportResult', data)
        } else {
          data.id = this.data.id
          await this.$store.dispatch('editFaultSupportResult', data)
        }

        if (this.$store.getters.getStatus == 'Success') {
          await this.$store.dispatch('listFaultSupportResults')
        }

        this.saveState(false);
        this.modalEvent(false);
      })
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/FaultSupportResults.vue